const lang = {
  namespaced: true,
  state: {
    //EN zhHant zhHans
    currentLang: "EN"
  },
  mutations: {
    setCurrentLang(state, payload) {
      localStorage.setItem("LANG", payload);
      state.currentLang = payload;
    }
  },
  actions: {},
  getters: {}
};

export default lang;
